module.exports = __webpack_public_path__ + "static/media/login_logo.e6cea06b.png";